import { signal } from "@preact/signals-react";
import axios from "axios";
import { userData } from "../../Common/Store/CommonSignals";
import { template } from "../../Entry/Manage/EditEntrySignals";
import { graphUserByEmailUrl } from "../../Utilities/GraphUserLookup";

// Session-lifetime cache of resolved display names and IDs, keyed by lowercased email.
// A signal so any calculated-field effect reading DisplayName() or Id() re-runs once
// a lookup resolves.
const resolvedData = signal({});
const pendingLookups = new Set();

function fetchUserData(email) {
  const key = email.toLowerCase();
  if (pendingLookups.has(key)) return;
  pendingLookups.add(key);

  axios
    .get(graphUserByEmailUrl(email))
    .then((response) => {
      console.log(response);
      const user = response.data?.value?.[0];
      resolvedData.value = {
        ...resolvedData.value,
        [key]: {
          displayName: user?.displayName ?? "",
          id: user?.id ?? "",
          employeeId: user?.employeeId ?? "",
        },
      };
    })
    .catch((err) => {
      console.error("[author] Failed to resolve display name and ID for", email, err);
    })
    .finally(() => {
      pendingLookups.delete(key);
    });
}

export function author() {
  const email = template.value?.entryAuthor || userData.value?.userEmail || "";

  return {
    Email: () => email,
    DisplayName: () => {
      if (!email) return "";

      const key = email.toLowerCase();
      const cached = resolvedData.value[key];
      if (cached === undefined) fetchUserData(email);
      return cached?.displayName ?? "";
    },
  };
}
